import { render, staticRenderFns } from "./Dns.vue?vue&type=template&id=be3ecf6a&scoped=true"
import script from "./Dns.vue?vue&type=script&lang=js"
export * from "./Dns.vue?vue&type=script&lang=js"
import style0 from "./Dns.vue?vue&type=style&index=0&id=be3ecf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3ecf6a",
  null
  
)

export default component.exports